import { Button, Modal } from '@react-apps/design-system';
import { getApiErrorMessage } from '../display';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: string;
  confirmLabel?: string;
  loading?: boolean;
  error?: unknown;
  danger?: boolean;
}

/** Modal genérico de confirmação (usado para exclusões e ações destrutivas). */
export function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = 'Confirmar',
  loading,
  error,
  danger = true,
}: ConfirmModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      description={description}
    >
      <div className="space-y-4">
        {error != null && (
          <p className="text-sm text-red-600">
            {getApiErrorMessage(error, 'Falha na operação')}
          </p>
        )}
        <div className="flex justify-end gap-2">
          <Button type="button" variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            type="button"
            variant={danger ? 'danger' : 'primary'}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Processando…' : confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
